import actions from './actions';

export default {
  state: () => ({
    data: {},
  }),
  mutations: {
    'cabinet/setState'(state, payload) {
      state.data = { ...payload };
    },
  },
  actions,
};
